import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";
import {  ICenterPrinterPayload } from "../../../../../Booklet_Admin/Master/Center_Printer/ICenterPrinter";

export const CentreMasterMappingCreateSlice = createSlice({
  name: "CentreMasterMappingCreateSlice",
  initialState: {} as IReduxState<ICenterPrinterPayload>,
  reducers: {
    centreMasterMappingCreate: (state, _: PayloadAction<ICenterPrinterPayload>) => {
      state.isLoading = true;
    },
    successCentreMasterMappingCreate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureCentreMasterMappingCreate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearCentreMasterMappingCreate: (state) => {
      state.data = {};
    },
  },
});

export const {
  centreMasterMappingCreate,
  failureCentreMasterMappingCreate,
  successCentreMasterMappingCreate,
  clearCentreMasterMappingCreate,
} = CentreMasterMappingCreateSlice.actions;

export default CentreMasterMappingCreateSlice.reducer;
